import { createSlice } from "@reduxjs/toolkit";

const drmCEAZipDownloadSlice = createSlice({
  name: "zipData",
  initialState: {
    blob: {},
    isLoading: false,
    isFileExist: '',
    errorMessage: undefined,
  },
  reducers: {
    getDrmZipReportData: (state) => {
      state.isLoading = true;
    },
    setDrmZipReportDataSuccess: (state, action) => {
      state.blob = action.payload;
      state.isLoading = false;
      state.isFileExist= 'exist';
    },
    setDrmZipReportDataNotExist: (state, action) => {
      state.isLoading = false;
      state.isFileExist= 'not_exist';
      state.errorMessage = action.payload;
    },
    setDrmZipReportDataFailure: (state, action) => {
      state.isLoading = false;
      state.isFileExist= 'not_exist';
      state.errorMessage = action.payload;
    },
    resetZipReportData: (state) => {
      state.blob = {};
      state.isLoading = false;
      state.isFileExist = '';
      state.errorMessage = undefined;
    },
  },
});

export const {
  getDrmZipReportData,
  setDrmZipReportDataSuccess,
  setDrmZipReportDataFailure,
  resetZipReportData,
  setDrmZipReportDataNotExist
} = drmCEAZipDownloadSlice.actions;

export default drmCEAZipDownloadSlice.reducer;
